<template>
  <g>
    <path
      d="M21.0398 21.83H3.79018C3.35558 21.83 3 21.4744 3 21.0398V3.79018C3 3.35558 3.35558 3 3.79018 3C4.22478 3 4.58036 3.35558 4.58036 3.79018V20.2496H21.0398C21.4744 20.2496 21.83 20.6052 21.83 21.0398C21.83 21.4823 21.4823 21.83 21.0398 21.83Z"
      :fill="iconColor"
    />
    <path
      d="M9.54898 18.9698H6.63322C6.23022 18.9698 5.90625 18.6459 5.90625 18.2429V14.1576C5.90625 13.7546 6.23022 13.4307 6.63322 13.4307H9.54898C9.95197 13.4307 10.2759 13.7546 10.2759 14.1576V18.2429C10.2759 18.638 9.95197 18.9698 9.54898 18.9698ZM7.36808 17.508H8.82202V14.8846H7.36808V17.508Z"
      :fill="iconColor"
    />
    <path
      d="M20.8107 18.9696H17.8949C17.4919 18.9696 17.168 18.6456 17.168 18.2426V3.7902C17.168 3.38721 17.4919 3.06323 17.8949 3.06323H20.8107C21.2137 3.06323 21.5377 3.38721 21.5377 3.7902V18.2347C21.5456 18.6377 21.2137 18.9696 20.8107 18.9696ZM18.6298 17.5077H20.0837V4.51716H18.6298V17.5077Z"
      :fill="iconColor"
    />
    <path
      d="M15.1857 18.9715H12.2699C11.8669 18.9715 11.543 18.6475 11.543 18.2445V9.08634C11.543 8.68335 11.8669 8.35938 12.2699 8.35938H15.1857C15.5887 8.35938 15.9127 8.68335 15.9127 9.08634V18.2366C15.9127 18.6396 15.5887 18.9715 15.1857 18.9715ZM12.9969 17.5097H14.4508V9.81331H12.9969V17.5097Z"
      :fill="iconColor"
    />
  </g>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
@Options({
  props:{
	iconColor: 	{
	    type: String,
	    default: "#616161"
	  }
  }
})
export default class IconBarGraph extends Vue {
  iconColor!: string;
}
</script>
